import { useQuery } from "@tanstack/react-query";
import { crmApi } from "../api/client";
import { useSelectedProject } from "../contexts/SelectedProjectProvider";

const MANAGER_REVIEW_KEY = ["crm", "dashboard", "manager-review"];

export function useManagerReview({ weekStart, stuckDays = 7 } = {}) {
  // Scope to the selected project (matches the top project switcher, like the
  // main dashboard). No project selected → org-wide.
  const { projectId } = useSelectedProject();
  return useQuery({
    queryKey: [...MANAGER_REVIEW_KEY, { weekStart, stuckDays, projectId }],
    queryFn: async () => {
      const params = {};
      if (weekStart) params.weekStart = weekStart;
      if (stuckDays) params.stuckDays = stuckDays;
      if (projectId) params.projectId = projectId;
      const { data } = await crmApi.get("/dashboard/manager-review", { params });
      return data;
    },
    staleTime: 55_000,
  });
}
